<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" max-width="800">
      <v-card>
        <v-card-title style="background-color:#1e345d; color:white;" class="headline">
            {{checklistItem.label}}
          <v-spacer></v-spacer>
          <v-btn dark icon @click="toggle"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-container>
          <v-row align="center">
              <v-flex xs12 sm2>
                <p style="margin:25px; font-size:16px;">Checked</p>
              </v-flex>
              <v-flex xs12 sm10 style="float:left">
                <v-flex style="display:inline-flex; float: right; padding-right: 16px">
                    <v-checkbox :disabled="isDisabled" style="margin-right:7px" success id="yesValue" v-model="checklistItem.yesChecked" label="Complete"></v-checkbox>
                    <v-checkbox :disabled="isDisabled" style="margin-left:7px" error id="noValue" v-model="checklistItem.noChecked" label="Required"></v-checkbox>
                    <v-checkbox :disabled="isDisabled" style="margin-left:7px" info id="naValue" v-model="checklistItem.naChecked" label="N/A"></v-checkbox>
                </v-flex>
            </v-flex>
            <v-flex xs12><v-divider></v-divider></v-flex>
            </v-row>
            <v-row align="center">
              <v-flex xs3>
                <p read-only style="margin:25px; font-size:16px;">Checked By</p>
              </v-flex>
              <v-flex xs9 style="float: right">
                    <p style="margin:25px; font-size:16px; float: right;">{{checklistItem.checkedBy}}</p>
            </v-flex>
            <v-flex xs12><v-divider></v-divider></v-flex>
            </v-row>
            <v-row style="max-height:74px" v-if="checklistItem.type.toLowerCase() === 'date'" align="center">
                <v-flex xs2 style="max-height:74px">
                    <p style="margin:25px; font-size:16px">Date</p>
                </v-flex>
                <v-flex xs7 style="max-height:74px"></v-flex>
                <v-flex xs3 style="max-height:74px">
                    <v-flex style="max-height:74px;">
                        <v-menu
                            v-model="showDateDialog"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <v-date-picker v-model="checklistItem.info" @input="showDateDialog = false"></v-date-picker>
                            <template v-slot:activator="{ on }">
                                <v-text-field :disabled="isDisabled"  class="text-xs-center" style="margin:25px; font-size:16px!important;" v-model="checklistItem.info" :clearable="true" label="Date" readonly v-on="on"></v-text-field>
                            </template>
                        </v-menu>
                    </v-flex>
                </v-flex>
                <v-flex xs12><v-divider></v-divider></v-flex>
            </v-row>
            <v-row v-else-if="checklistItem.type.toLowerCase() === 'number'">
                <v-flex xs8>
                    <p style="margin:25px; font-size:16px">Required Amount</p>
                </v-flex>
                <v-flex xs2></v-flex>
                <v-flex xs2>
                    <p style="margin:25px; font-size:16px">{{checklistItem.info}}</p>
                </v-flex>
            <v-flex xs12><v-divider></v-divider></v-flex>
            </v-row>
            <v-row align="center">
              <v-flex xs2 style="max-height:74px">
                  <p style="margin:25px; font-size:16px">Required</p>
              </v-flex>
              <v-flex xs10>
                  <v-checkbox :disabled="isDisabled" style="margin-right:7px; float: right;" color="#2196f3" id="required" v-model="checklistItem.required"></v-checkbox>
              </v-flex>
              <v-flex xs12><v-divider></v-divider></v-flex>
            </v-row>
            <v-row align="center">
              <v-flex xs2 style="max-height:74px">
                  <p style="margin:25px; font-size:16px">Documents</p>
              </v-flex>
              <v-flex xs5></v-flex>
              <v-flex xs5>
                <v-list>
                  <v-list-item-group v-model="documents">
                    <v-list-item
                      v-for="(document, i) in documents"
                      :key="i"
                    >
                      <v-list-item-content>
                        <v-list-item-title @click="getDocumentLink(document)" v-text="document.fileName"></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon v-if="!isDisabled">
                        <v-icon color="error" @click="showDeleteDialog = true">mdi-delete</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-flex>
              <v-flex xs12><v-divider></v-divider></v-flex>
            </v-row>
            <v-row align="center">
              <template>
                <v-row justify="center">
                  <v-dialog v-model="showDeleteDialog" persistent max-width="290">
                    <v-card>
                      <v-card-title class="headline pt-1 pr-1">
                        Confirm Delete
                        <v-spacer></v-spacer>
                        <v-btn icon @click="showDeleteDialog = false"><v-icon>close</v-icon></v-btn>
                      </v-card-title>
                      <v-card-text class="pb-1"> Are you sure you want delete this document?</v-card-text>
                      <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn outlined color="error" @click="deleteDocument">Delete</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </template>
              <v-flex xs2 style="max-height:74px">
                  <p style="margin:25px; font-size:16px">Images</p>
              </v-flex>
              <v-flex xs5></v-flex>
              <v-flex xs5>
                <v-list>
                  <v-list-item-group v-model="images">
                    <v-list-item
                      v-for="(image, i) in images"
                      :key="i"
                    >
                      <v-list-item-content>
                        <v-list-item-title @click="getImageLink(image)" v-text="image.fileName"></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon v-if="!isDisabled">
                        <v-icon color="error" @click="showDeleteDialog = true">mdi-delete</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-flex>
              <v-flex xs12><v-divider></v-divider></v-flex>
            </v-row>
            <v-row>
            <v-flex xs12>
                <v-textarea :disabled="isDisabled" label="Notes" style="font-size:16px" v-model="checklistItem.notes" auto-grow rounded></v-textarea>
            </v-flex>
        </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'checklist-details',
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    checklistItem: {
      type: Object,
      required: true
    },
    currentUser: {
      type: Object,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
     saveUpdatedChecklist: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    showDateDialog: false,
    docTypeToDelete: null,
    showDeleteDialog: false,
    docIndexToDelete: null
  }),

  methods: {
    ...mapActions({
      loadDocInPage: 'document/getDocLink',
      loadImageInPage: 'image/getImageLink',
      deleteImage: 'image/deleteImage',
      deleteNonImage: 'document/deleteDocument'
    }),

    async getDocumentLink (file) {
      await this.loadDocInPage(file)
    },
    async getImageLink (file) {
      await this.loadImageInPage(file.id)
    },
    deleteDocument () {
      if (this.docTypeToDelete === 'images') {
        this.deleteImage(this.checklistItem.images[this.docIndexToDelete].id)
        this.checklistItem.images.splice(this.docIndexToDelete, 1)
        this.toggleDelete()
      } else if (this.docTypeToDelete === 'documents') {
        this.deleteNonImage( this.checklistItem.documents[this.docIndexToDelete].id)
        this.checklistItem.documents.splice(this.docIndexToDelete, 1)
        this.toggleDelete()
      }
      this.saveUpdatedChecklist() //file removed, saves the checklist with updated file list
    },

    toggleDelete () {
      this.showDeleteDialog = !(this.showDeleteDialog)
    }
  },
  computed: {
    ...mapGetters({
      userRole: 'user/role'
    }),
    documents: {
      get () {
        return this.checklistItem.documents
      },
      set (value) {
        if (value !== undefined || value !== null) {
          this.docTypeToDelete = 'documents'
          this.docIndexToDelete = value
        }
      }
    },
    images: {
      get () {
        return this.checklistItem.images
      },
      set (value) {
        if (value !== undefined || value !== null) {
          this.docTypeToDelete = 'images'
          this.docIndexToDelete = value
        }
      }
    },
    isDisabled () {
      if (this.userRole === 'Sub Foreman') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style scoped>
.v-list-item__icon:first-child {
    margin-right: 10px;
}
</style>
